export enum AuthStates {
    LOGIN_INITIAL_STATE,
    LOGIN_REDIRECT,
    LOGOUT_REDIRECT,
    LOGIN_PROCESSING,
    LOGIN_COMPLETE,
    LOGIN_FAILED,
    USER_NOT_ASSIGNED
}
